import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {PhotovoltaikcheckRequestService} from "../services/request.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PortalService} from "../../services/portal.service";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {ActivatedRoute, Router} from "@angular/router";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";
import {ElementService} from "../../services/element.service";

/**
 * Component for the entry of the moderat. Let the user select its interests.
 */
@Component({
    selector: 'app-moderat-einstieg',
    templateUrl: './einstieg.component.html',
    standalone: false
})
export class EinstiegComponent implements OnInit {
  /**
   * path to the first page.
   */
  readonly PATH_FIRSTPAGE = '../eingabe/basisdaten/1';

  /**
   * the current userdata
   */
  anfrage: PhotovoltaikcheckAnfrage;

  /**
   * current path in the advisor.
   */
  pathBalcony: boolean = false;

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * form for validation
   */
  form: UntypedFormGroup;

  /**
   * options for the paths of the advisor
   */
  interestList = [PhotovoltaikcheckConstants.PATH_PVANLAGE, PhotovoltaikcheckConstants.PATH_BALKONKRAFTWERK];

  /**
   * Toggle for showing the error if no option is selected
   */
  showError: boolean = false;

  /**
   * html element that we want to scroll to after the iuser has selected an interest.
   */
  @ViewChild('submit') submit: ElementRef;

  /**
   * constructor
   * @param requestService
   * @param portalService
   * @param router
   * @param route
   * @param elementService
   */
  constructor(private requestService: PhotovoltaikcheckRequestService, protected portalService: PortalService, protected router: Router,
              protected route: ActivatedRoute, protected elementService: ElementService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.anfrage = this.requestService.getAnfrage();

    // Read path parameter from route data
    this.anfrage.path = this.route.snapshot.data.path ?? PhotovoltaikcheckAnfrage.PATH_ALL;
    this.pathBalcony = this.anfrage.path === PhotovoltaikcheckAnfrage.PATH_BALCONY;

    if (this.pathBalcony === true){
      this.anfrage.interesse = PhotovoltaikcheckConstants.PATH_BALKONKRAFTWERK;
    }

    this.requestService.setAnfrage(this.anfrage);

    // init Placeholder
    this.welcomePlaceholder = {
      portalPlaceholder: this.portalService.getConfig('embed.portal.welcometext') ?
        (' ' + this.portalService.getConfig('embed.portal.welcometext')) : ''
    };

    // initialize the form
    this.initForm();
  }

  /**
   * Inits the form with all the needed input fields.
   * @private
   */
  private initForm(): void {
    // create form and add inputs
    this.form = new UntypedFormGroup({
      interesse: new UntypedFormControl(this.anfrage.interesse, Validators.required)
    });
  }

  /**
   * scroll to the submit button
   */
  scrollDown(): void {
    this.elementService.scrollToElement(this.submit.nativeElement);
  }

  /**
   * The form is submitted
   *
   */
  onSubmit(): void {
    if(this.form.valid === true) {
      this.saveData();

      // show text Step
      this.nextStep();
    }
  }

  /**
   * Click on the submit button
   */
  onSubmitClick(): void {
    if(this.form.valid === false) {
      this.showError = true;
    }
  }

  /**
   * save the selection of interests
   */
  saveData(): void {
    this.anfrage.interesse = this.form.get('interesse').value;
    this.requestService.setAnfrage(this.anfrage);

    // save to server
    this.requestService.saveDataToServer();
  }

  /**
   * moveon to the next step
   */
  nextStep(): void {
    // forward to first chapter
    this.router.navigate([this.PATH_FIRSTPAGE], {
      relativeTo: this.route
    });
  }

}
